import { tokens, primitives } from '../assets/tokens'

const { color } = tokens

// Estilos de react-select alineados con los inputs del tema (MuiOutlinedInput) y con
// AutocompleteSelect de Velora: 40 px, borde de 1,5 px en gris, radio 8, hover y foco en el
// color del cliente. `overrides` se fusiona por clave para ajustes puntuales de cada pantalla.
export const veloraSelectStyles = (primaryColor = color.brand.primary, overrides = {}) => {
  const base = {
    control: (provided, state) => ({
      ...provided,
      minHeight: 40,
      borderRadius: 8,
      borderWidth: 1.5,
      borderStyle: 'solid',
      borderColor: state.isFocused ? primaryColor : color.border.default,
      backgroundColor: state.isDisabled ? color.background.muted : color.background.default,
      boxShadow: 'none',
      fontFamily: tokens.typography.fontFamily.primary,
      fontSize: 14,
      '&:hover': { borderColor: primaryColor }
    }),
    valueContainer: provided => ({ ...provided, padding: '2px 12px' }),
    placeholder: provided => ({ ...provided, color: color.text.disabled, fontSize: 14 }),
    singleValue: provided => ({ ...provided, color: color.text.primary, fontSize: 14 }),
    input: provided => ({ ...provided, fontSize: 14, color: color.text.primary }),
    indicatorSeparator: () => ({ display: 'none' }),
    // X y chevron juntos (2 px) y centrados; los iconos salen de react-select-components
    indicatorsContainer: provided => ({ ...provided, gap: 2, paddingRight: 8 }),
    dropdownIndicator: provided => ({ ...provided, color: primitives.neutral[800], padding: 3, '&:hover': { color: primitives.neutral[800] } }),
    clearIndicator: provided => ({ ...provided, padding: 3, cursor: 'pointer' }),
    multiValue: provided => ({ ...provided, backgroundColor: color.background.light, borderRadius: 6 }),
    multiValueLabel: provided => ({ ...provided, fontSize: 12, color: color.text.dark, padding: '3px 6px' }),
    multiValueRemove: provided => ({ ...provided, borderRadius: 6, ':hover': { backgroundColor: color.background.muted, color: color.text.primary } }),
    menu: provided => ({ ...provided, borderRadius: 8, boxShadow: tokens.shadow.md, zIndex: 1400 }),
    menuPortal: provided => ({ ...provided, zIndex: 1400 }),
    option: (provided, state) => ({
      ...provided,
      fontSize: 14,
      color: color.text.primary,
      backgroundColor: state.isSelected ? color.background.light : state.isFocused ? color.background.surface : color.background.default,
      ':active': { backgroundColor: color.background.light }
    })
  }

  return Object.keys(overrides).reduce((styles, key) => {
    const baseFn = styles[key]
    const override = overrides[key]
    styles[key] = (provided, state) => override(baseFn ? baseFn(provided, state) : provided, state)
    return styles
  }, base)
}

export default veloraSelectStyles
